/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EmployeeWorkHours/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import CoreEmbeddableSection from 'DesignSystem/CoreEmbeddableSection/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function EmployeeWorkHours({
  children,
  viewPath = "/App/Account/Content/EmployeeWorkHours"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let tabCoreParamsValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'coreParams',
})
let globalRefreshEmbeddedSectionValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'refresh_embedded_section',
})
let globalSessionExpiredRefreshEmbeddedSectionValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'session_expired_refresh_embedded_section',
})
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 marginTop={0}
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={0}
 paddingRight={0}
 paddingBottom={0}
 paddingLeft={0}
 overflowX="hidden"
 overflowY="hidden"
>
{childProps => (
<div
  data-testid="EmployeeWorkHours.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="EmployeeWorkHours.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-1oxKeO': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-1oxKeO': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-3-1oxKeO': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-1oxKeO': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 onClick={onClick}
 type="secondary"
 text="Open reports"
/>
</div>
<CoreEmbeddableSection
  viewPath={`${viewPath}/CoreEmbeddableSection`}
 section_type="employee_work_hours"
 data="global.current_location._id"
 location_id={globalCurrentLocationIdValueData}
 data="tab.coreParams"
 params={tabCoreParamsValueData}
 data="global.refresh_embedded_section"
 refresh={globalRefreshEmbeddedSectionValueData}
 data="global.session_expired_refresh_embedded_section"
 session_expired_refresh={globalSessionExpiredRefreshEmbeddedSectionValueData}
/>
</div>
)}
</TysiaCardContent>
)}
</TysiaCard>
{children}
</React.Fragment>)
}